































import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
import {
  AuditFlowScope,
  DataDictionaryDtoPagedResultDto, TrainApplyDto,
  TrainRecordDto
} from "@/api/appService";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";

@Component({
  name: "AuditTabOfTrainApplyCheckIn",
  components: {
    AuditTabPane,
    AgileAuditTag,
  },
  filters: {
    formatType(type: string, typeList: any[]) {
      let result = "";
      typeList.forEach((item) => {
        if (item.value == type) {
          result = item.text;
          return;
        }
      });
      return result;
    },
  },
})
export default class AuditTabOfTrainApplyCheckIn extends Vue {
  tableItems: TrainApplyDto[] = [];
  typeList: any = [];

  queryForm: any = {
    name: "",
    projectType: "",
  };

  // 获取表数据
  get fetchData() {
    return api.trainApply.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "trainApplyDetail",
      params: {
        id: dto.id,
      },
    });
  }

  // 审核记录
  handleFlowDetail(dto: any) {
    this.$router.push({
      name: "auditFlowDetail",
      params: {
        hostType: AuditFlowScope.TrainApply,
        hostId: dto.id,
        auditFlowId: dto.auditFlowId,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
